import { render, staticRenderFns } from "./datacollect-form-4.vue?vue&type=template&id=f34c5ecc&scoped=true&"
import script from "./datacollect-form-4.vue?vue&type=script&lang=ts&"
export * from "./datacollect-form-4.vue?vue&type=script&lang=ts&"
import style0 from "./datacollect-form-4.vue?vue&type=style&index=0&id=f34c5ecc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34c5ecc",
  null
  
)

export default component.exports